import { Input, Row, Col } from '@iqueue/ui-kit'
import { v4 as uuid } from 'uuid'
import PermissionsTable from '../../components/PermissionsTable'
import { t } from '../../hooks/useTranslate'

export default function RoleUpsertForm({ model }) {
  return <div>
    <Row>
      <Input
        auxil iary
        name={ 'id' }
        hidden
        value={ model.id || uuid }
      />
    </Row>
    <Row>
      <Input
        size={ 12 }
        name={ 'name' }
        value={ model.name }
        placeholder={ t('rolesPage.form.namePlaceholder') }
      />
    </Row>

    <Row>
      <Col size={ 12 }>
        <PermissionsTable
          data={ model || {} }
        />
      </Col>
    </Row>
  </div>
}
